import { getAvailableTabsConfig } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMConsts";
import type { EAvailableTabs, ITabData } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";

interface ITabMetadata {
    id: EAvailableTabs;
    data: ITabData;
    index: number;
}

interface ILLMTabsProps {
    currentTab: ITabMetadata;
    getTabMetadataByIndex: (index: number) => ITabMetadata;
    getTabMetadataById: (id: EAvailableTabs) => ITabMetadata;
}

const getTabMetadataByIndex = (index: number): ITabMetadata => {
    const tabIndex = index !== -1 ? index : 0;
    const config = getAvailableTabsConfig();

    return {
        index: tabIndex,
        data: Object.values(config)[tabIndex],
        id: Object.keys(config)[tabIndex] as EAvailableTabs,
    };
};

const getTabMetadataById = (id: EAvailableTabs): ITabMetadata => {
    const config = getAvailableTabsConfig();
    const tabKeys = Object.keys(config) as EAvailableTabs[];

    return {
        index: tabKeys.findIndex((key) => key === id),
        data: config[id],
        id,
    };
};

export const useLLMTabs = (): ILLMTabsProps => {
    const config = getAvailableTabsConfig();
    const currentIndex = Object.values(config).findIndex((tab: ITabData) =>
        proNavigator.isCurrentStateName(tab.stateId),
    );

    return {
        currentTab: getTabMetadataByIndex(currentIndex),
        getTabMetadataByIndex,
        getTabMetadataById,
    };
};
